import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { TextArea } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import commonPropTypes from '../../../constants/commonPropTypes'
import { formFieldWrapper } from '../formFieldWrapper'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const BaseTextAreaField = ({
  elmId,
  value,
  onChange,
  onBlur,
  placeholder,
  label,
  normalizeOnBlur,
  showError,
  className,
  compact = false,
  disabled,
  ...rest
}) => {
  const onBlurNew = e => {
    if (normalizeOnBlur) {
      e.target.value = normalizeOnBlur(e.target.value)
    }
    onBlur && onBlur(e)
  }

  const finalValue = _.isNil(value) ? '' : String(value)

  return (
    <TextArea
      data-elm-id={`${elmId}_textarea`}
      value={finalValue}
      onChange={onChange}
      onBlur={onBlurNew}
      placeholder={placeholder || label}
      className={cx(className, 'textarea', {
        error: showError,
        disabled,
        compact,
      })}
      disabled={disabled}
      {...rest}
    />
  )
}

BaseTextAreaField.propTypes = {
  ...commonPropTypes,
  normalizeOnBlur: PropTypes.func,
  compact: PropTypes.bool,
}

export default formFieldWrapper((fieldProps, showError) => (
  <BaseTextAreaField {...fieldProps} showError={showError} />
))
